module.exports = "data:image/x-icon;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmYXZpY29uLmljbyI7"


//////////////////
// WEBPACK FOOTER
// ./app/favicon.ico
// module id = 1421
// module chunks = 0